// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.shared.category.CreateRelatedCategoryRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateRelatedCategoryRequest extends GandalfModelBase {

	@GandalfLabel('Category')
	@GandalfValidator({ notNull: { message: 'Category is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	categoryId!: number;

	@GandalfLabel('Value Category')
	@GandalfProperty({ designType: Number })
	valueCategoryId!: number | null;

}
